// extracted by mini-css-extract-plugin
export default {"link":"sD-z","disabled":"tD-z"};